import { render } from "./CabinetPage.vue?vue&type=template&id=1a701196"
import script from "./CabinetPage.vue?vue&type=script&lang=js"
export * from "./CabinetPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__